import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

// @material-ui/icons
import School from '@material-ui/icons/School';
import AddAlert from '@material-ui/icons/AddAlert';
import Email from '@material-ui/icons/Email';
import LockOutlined from '@material-ui/icons/LockOutlined';

// material-ui components
import withStyles from '@material-ui/core/styles/withStyles';
import Checkbox from '@material-ui/core/Checkbox';

// core components
import Button from 'components/CustomButtons/Button';
import GridContainer from 'components/Grid/GridContainer';
import ItemGrid from 'components/Grid/ItemGrid';
import IconCard from 'components/Cards/IconCard';
import CustomInput from 'components/CustomInput/CustomInput';
import CustomPasswordInput from '../../components/CustomInput/CustomPasswordInput';
import CustomSelect from 'components/CustomInput/CustomSelect';
import CustomAutoComplete from 'components/CustomInput/CustomAutoComplete';
import ErrorBoundaries from 'components/Wrapper/ErrorBoundaries';
import Snackbar from 'components/Snackbar/Snackbar';
import ImageUpload from '../../components/CustomUpload/ImageUpload';

// others
import config from 'config';
import { Context } from 'context/Context';
import FormHOC from 'hoc/FormHOC';
import detailsPageStyle from 'views/Common/style/detailsPageStyle';
import cx from 'classnames';
import { transformPhone } from 'helpers/helpers';
import { JOBS, OTHER_JOB_ENTRY, OTHER_JOB_PREFFIX } from 'data';

class CollegeRegister extends Component {
  state = {
    colleges: [],
    selectedCollege: {},
  };

  componentDidMount() {
    this.fetchColleges();
  }

  componentWillUnmount() {
    this.props.context.closeSnackbar();
  }

  fetchColleges = () => {
    axios
      .get(`${config.API_URL}/public/colleges/modifiedRep`)
      .then((response) => {
        this.setState({ colleges: response.data });
      })
      .catch(() => {
        this.props.context.handleSnackbar({
          status: 'danger',
          message: 'Problème serveur pour obtenir les colleges !',
        });
      });
  };

  signUp = () => {
    if (!this.props.location.state) return this.props.history.push('/auth');
    const { type } = this.props.location.state;

    const phone = transformPhone(this.props.phone);
    const { access_token } = this.state;

    const {
      email,
      password,
      college,
      firstName: first_name,
      lastName: last_name,
      job,
      jobDetail,
      educationPass,
      handleOnSubmit,
      handleSignUp,
      context,
    } = this.props;

    // Cas données NON VALIDES dans le formulaire affiché
    const validations = [
      ...[
        'college',
        'email',
        'firstName',
        'lastName',
        'phone',
        'job',
        'password',
        'confirmPassword',
        'educationPass',
        'checkboxCgu',
      ],
    ];

    if (job === OTHER_JOB_ENTRY) {
      validations.push('jobDetail');
    }

    if (!handleOnSubmit(validations)) {
      return null;
    }

    const body = {
      access_token,
      email,
      password,
      type,
      college,
      first_name,
      last_name,
      educationPass,
      job: job === OTHER_JOB_ENTRY ? OTHER_JOB_PREFFIX + jobDetail : job,
      ...(phone && { phone }),
    };

    handleSignUp('', body, context);
  };

  render() {
    const {
      classes,
      email,
      emailState,
      passwordState,
      confirmPasswordState,
      educationPassState,
      educationPassLoading,
      firstName,
      firstNameState,
      lastName,
      lastNameState,
      job,
      jobState,
      jobDetail,
      jobDetailState,
      checkboxCguState,
      checkboxCgu,
      collegeAutoComplete,
      collegeState,
      phoneState,
      handleOnChange,
      handleOnSelect,
      handleChangeImage,
      handleRemoveImage,
    } = this.props;
    const {
      closeSnackbar,
      state: { snackbar },
    } = this.props.context;

    const educationPassTitle = cx({
      [classes.text]: true,
      [classes.dangerColor]: educationPassState === 'error',
      [classes.successColor]: educationPassState === 'success',
    });

    // noinspection DuplicatedCode
    const content = (
      <GridContainer className={classes.topMargin}>
        <ItemGrid xs={12} sm={6}>
          <CustomInput
            success={emailState === 'success'}
            error={emailState === 'error'}
            labelText={
              <span>
                <Email className={classes.inputLabelIcon} /> Email <small>(obligatoire)</small>
              </span>
            }
            id='email'
            value={email || ''}
            formControlProps={{
              fullWidth: true,
            }}
            inputProps={{
              type: 'email',
              onChange: (event) => handleOnChange(event.target.value, 'email', 'email'),
            }}
            required
          />
          <CustomPasswordInput
            success={passwordState === 'success'}
            error={passwordState === 'error'}
            labelText={
              <span>
                <LockOutlined className={classes.inputLabelIcon} /> Mot de passe <small>(obligatoire)</small>
              </span>
            }
            id='password'
            formControlProps={{
              fullWidth: true,
            }}
            inputProps={{
              type: 'password',
              onChange: (event) => handleOnChange(event.target.value, 'password', 'password'),
            }}
            required
          />
          <CustomPasswordInput
            success={confirmPasswordState === 'success'}
            error={confirmPasswordState === 'error'}
            labelText={
              <span>
                <LockOutlined className={classes.inputLabelIcon} /> Confirmez le mot de passe{' '}
                <small>(obligatoire)</small>
              </span>
            }
            id='confirmPassword'
            formControlProps={{
              fullWidth: true,
            }}
            inputProps={{
              type: 'password',
              onChange: (event) => handleOnChange(event.target.value, 'confirmPassword', 'equalTo', 'password'),
            }}
            required
          />
          <CustomAutoComplete
            success={collegeState === 'success'}
            error={collegeState === 'error'}
            labelText={
              <div className={classes.inputLabelWithoutIcon}>
                Nom du collège <small>(obligatoire)</small>
              </div>
            }
            value={collegeAutoComplete || ''}
            data={this.state.colleges}
            handleChange={(event) => handleOnChange(event.target.value, 'college', 'autocomplete')}
            handleSelect={async (name, id) => {
              this.setState({ selectedCollege: id });
              handleOnSelect(name, id, 'college');
            }}
            required
          />
        </ItemGrid>
        <ItemGrid xs={12} sm={6}>
          <CustomInput
            success={firstNameState === 'success'}
            error={firstNameState === 'error'}
            labelText={
              <div className={classes.inputLabelWithoutIcon}>
                Prénom <small>(obligatoire)</small>
              </div>
            }
            id='firstname'
            value={firstName || ''}
            formControlProps={{
              fullWidth: true,
            }}
            inputProps={{
              onChange: (event) => handleOnChange(event.target.value, 'firstName', 'length', 3),
            }}
            required
          />
          <CustomInput
            success={lastNameState === 'success'}
            error={lastNameState === 'error'}
            labelText={
              <div className={classes.inputLabelWithoutIcon}>
                Nom de famille <small>(obligatoire)</small>
              </div>
            }
            id='lastname'
            value={lastName || ''}
            formControlProps={{
              fullWidth: true,
            }}
            inputProps={{
              onChange: (event) => handleOnChange(event.target.value, 'lastName', 'length', 3),
            }}
            required
          />
          <CustomInput
            success={phoneState === 'success'}
            error={phoneState === 'error'}
            labelText={
              <div className={classes.inputLabelWithoutIcon}>
                Téléphone <small>(obligatoire)</small>{' '}
              </div>
            }
            helpText='Vos coordonnées resteront confidentielles et ne seront pas transmises.'
            id='phone'
            formControlProps={{
              fullWidth: true,
            }}
            inputProps={{
              onChange: (event) => handleOnChange(event.target.value, 'phone', 'phone'),
            }}
            required
          />
          <CustomSelect
            id='selectJob'
            success={jobState === 'success'}
            error={jobState === 'error'}
            labelText={
              <div className={classes.inputLabelWithoutIcon}>
                Poste <small>(obligatoire)</small>
              </div>
            }
            formControlProps={{
              fullWidth: true,
            }}
            value={job || ''}
            data={JOBS.map((item) => ({ id: item, name: item }))}
            handleChange={(event) => {
              handleOnChange(event.target.value, 'job', 'select');
            }}
            required
          />
          {job === OTHER_JOB_ENTRY ? (
            <CustomInput
              success={jobDetailState === 'success'}
              error={jobDetailState === 'error'}
              id='jobDetail'
              value={jobDetail || ''}
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                onChange: (event) => handleOnChange(event.target.value, 'jobDetail', 'length', 3),
              }}
            />
          ) : null}
        </ItemGrid>

        {/* pass éducation */}
        <ItemGrid xs={12} sm={6}>
          <div className={classes.containerUploadAlignLeft}>
            <p className={educationPassTitle}>
              Prendre en photo mon pass éducation{' '}
              <small> (cela nous permet de nous assurer que vous êtes enseignant dans ce collège) </small>
            </p>
          </div>
          <ImageUpload
            success={educationPassState === 'success'}
            error={educationPassState === 'error'}
            color='white'
            labelText='Pass éducation'
            loading={educationPassLoading}
            handleChange={(e) => handleChangeImage(e, 'educationPass')}
            handleRemove={() => handleRemoveImage('educationPass')}
          />
        </ItemGrid>
      </GridContainer>
    );

    const footer = (
      <Fragment>
        <GridContainer direction='row' justifyContent='center' alignItems='center'>
          <ItemGrid>
            <Checkbox
              id='cgu-checkbox'
              onClick={() => handleOnChange(!checkboxCgu, 'checkboxCgu', 'checked')}
              value='cgu'
              checked={checkboxCgu ? 'checked' : ''}
              className={checkboxCguState === 'error' ? classes.checkboxError : ''}
              required
            />
          </ItemGrid>
          <ItemGrid>
            <label htmlFor='cgu-checkbox' style={{ cursor: 'pointer', userSelect: 'none' }}>
              J&apos;ai lu et j&apos;accepte les{' '}
              <a href='https://www.viensvoirmontaf.fr/mentions-legales/' rel='noopener noreferrer' target='_blank'>
                conditions générales d&apos;utilisation de ViensVoirMonTaf
              </a>{' '}
              et j&apos;atteste que les informations renseignées sont vraies
            </label>
          </ItemGrid>
        </GridContainer>
        <Button color='primary' onClick={() => this.signUp(this.props.context)}>
          Inscription
        </Button>
      </Fragment>
    );

    const snackbarContainer = snackbar && snackbar.isSnackbar && (
      <Snackbar
        key='snackbar'
        place='bc'
        color={snackbar.status}
        icon={AddAlert}
        message={snackbar.message}
        open={true}
        closeNotification={closeSnackbar}
        close
      />
    );

    return (
      <ErrorBoundaries>
        <div className={classes.content}>
          {snackbarContainer}
          <GridContainer justifyContent='center'>
            <ItemGrid xs={12} sm={10}>
              <form>
                <IconCard
                  icon={School}
                  iconColor='pink'
                  title='Inscription Profil Collège'
                  content={content}
                  footer={footer}
                  footerAlign='center'
                />
              </form>
            </ItemGrid>
          </GridContainer>
        </div>
      </ErrorBoundaries>
    );
  }
}

CollegeRegister.propTypes = {
  classes: PropTypes.object.isRequired,
  context: PropTypes.object.isRequired,
  handleOnChange: PropTypes.func.isRequired,
  handleOnSubmit: PropTypes.func.isRequired,
  handleChangeAddress: PropTypes.func.isRequired,
  handleSelectAddress: PropTypes.func.isRequired,
  handleChangeImage: PropTypes.func.isRequired,
  handleRemoveImage: PropTypes.func.isRequired,
  college: PropTypes.object,
  collegeState: PropTypes.string,
  educationPassLoading: PropTypes.bool,
  educationPassState: PropTypes.string,
  phone: PropTypes.string,
  phoneState: PropTypes.string,
  address: PropTypes.string,
  addressState: PropTypes.string,
  latitude: PropTypes.number,
  longitude: PropTypes.number,
  department: PropTypes.string,
};

const WrappedComponent = FormHOC(CollegeRegister);

export default withStyles(detailsPageStyle)((props) => (
  <Context.Consumer>{(context) => <WrappedComponent {...props} context={context} />}</Context.Consumer>
));
